/**
 * @module pages/HomePage
 * @description Landing page: branded hero with the edition's progress panel
 * as its focal point, followed by the postcard story gallery.
 */
import { ChallengePanel } from "../components/MatchMeter";
import { StoryPostcard } from "../components/StoryPostcard";
import { Postmark } from "../components/Brand";
import { usePublishedCards } from "../data";
import { hrefFor } from "../app/router";
import { useEdition } from "../app/edition";

export function HomePage() {
    const cards = usePublishedCards();
    const edition = useEdition();
    return (
        <>
            <section className="hero">
                <div className="hero-copy">
                    <p className="pc-kicker">{edition.hero.kicker}</p>
                    <h1 className="hero-title">
                        <span className="pc-script hero-script">
                            {/* Two-line break mirrors the pledge card: "To Jamaica, / With Love." */}
                            <span>To Jamaica,</span>
                            <span>With Love.</span>
                        </span>
                    </h1>
                    <p className="hero-lede">
                        {edition.hero.lede} <em>{edition.hero.ledeEmphasis}</em>
                    </p>
                    <div className="hero-actions">
                        <a className="btn btn--primary btn--lg" href={hrefFor({ name: "pledge", fromSlug: null })}>
                            {edition.hero.primaryCta}
                        </a>
                        <a className="btn btn--lg" href="#stories">{edition.hero.secondaryCta}</a>
                    </div>
                </div>
                <div className="hero-meter">
                    <Postmark kind={edition.postmark} />
                    <ChallengePanel variant="hero" />
                </div>
            </section>

            <section id="stories" className="gallery-wrap" aria-labelledby="stories-h">
                <header className="section-head">
                    <p className="pc-kicker">Postcards from Jamaica</p>
                    <h2 id="stories-h" className="section-title">This is your love at work.</h2>
                </header>
                <ul className="gallery">
                    {cards.map((card) => (
                        <li key={card.id}>
                            <a href={hrefFor({ name: "card", slug: card.slug })} className="gallery-link">
                                <StoryPostcard card={card} />
                            </a>
                        </li>
                    ))}
                </ul>
            </section>
        </>
    );
}
